import { createVar } from '@vanilla-extract/css';
import { themeVars } from '../theme/vars.ts';
import { borderRadius, space } from '../tokens.ts';
import { typography } from '../typography.ts';
import { style, styleVariants } from '../layer.css';

const containerBg = createVar();
const itemBgChecked = createVar();
const itemBorderChecked = createVar();

export const segmentedControl = style({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: containerBg,
  width: 'fit-content',
  padding: 0,
});

export const segmentedControlVariants = styleVariants({
  primary: {
    vars: {
      [containerBg]: themeVars.container.primary.background.idle,
      [itemBgChecked]: themeVars.container.primary.background.hover,
      [itemBorderChecked]: themeVars.container.border.secondary,
    },
  },
  secondary: {
    vars: {
      [containerBg]: themeVars.container.secondary.background.idle,
      [itemBgChecked]: themeVars.container.secondary.background.hover,
      [itemBorderChecked]: themeVars.container.border.secondary,
    },
  },
});

export const segmentedControlSizes = styleVariants({
  md: { borderRadius: borderRadius.r8 },
  sm: { borderRadius: borderRadius.r4 },
});

export type SegmentedControlVariant = keyof typeof segmentedControlVariants;
export type SegmentedControlSize = keyof typeof segmentedControlSizes;

export const segmentedControlItem = style({
  cursor: 'pointer',
  backgroundColor: 'transparent',
  color: themeVars.container.foreground.secondary,
  userSelect: 'none',
  transition: '.15s',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid transparent`,

  ':hover': {
    color: themeVars.container.foreground.primary,
  },

  selectors: {
    '&:where([aria-checked="true"], &[aria-pressed="true"]), &:where([aria-checked="true"], &[aria-pressed="true"]):hover':
      {
        backgroundColor: itemBgChecked,
        border: `1px solid ${itemBorderChecked}`,
        color: themeVars.container.foreground.primary,
      },
  },
});

export const segmentedControlItemSizes = styleVariants({
  md: [
    typography['bodySm'],
    {
      borderRadius: borderRadius.r8,
      padding: `${space.s8}px ${space.s20}px`,
      height: 32,
    },
  ],
  sm: [
    typography['labelSm'],
    {
      borderRadius: borderRadius.r4,
      padding: `${space.s4}px ${space.s12}px`,
      height: 24,
    },
  ],
});
